import { OuToolsTab } from './ouToolsTab';

require('./ouToolsTab.scss');

export const myOuToolsTab = {
  template: require('./ouToolsTab.html'),
  controllerAs: 'ctrl',
  controller: OuToolsTab,
};
